import React, { Component } from 'react'
import { connect } from 'react-redux'
import { handleChangeLang } from '../actions'
import store from '../store'

/**
 * Bootstrap styled Change Language View
 *
 * @author Pragya Gupta
 */

class LanguageComponent extends Component {
  render() {
    const { lang, landingNav } = this.props
    return (
      <select
        name="langOpt"
        className={
          landingNav
            ? 'selectpicker dashboard-nav-select1'
            : 'selectpicker dashboard-nav-select'
        }
        onChange={(name) => {
          store.dispatch(handleChangeLang(name.target.value))
        }}
        value={lang}
      >
        <option value="fi">FI</option>
        <option value="en">EN</option>
        <option value="est">EST</option>
        {/* <option value="ru">RU</option> */}
      </select>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.language.lang
  }
}

const Language = connect(mapStateToProps, { handleChangeLang })(
  LanguageComponent
)

export default Language
